import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { PHONE_TEL } from "@/data/services";

export const StickyCTA = () => (
  <div
    data-testid="sticky-mobile-cta"
    className="md:hidden fixed bottom-0 inset-x-0 z-50 jpd-glass border-t border-white/10 px-4 py-3 grid grid-cols-2 gap-3"
    style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
  >
    <a
      href={PHONE_TEL}
      data-testid="sticky-mobile-call-button"
      className="inline-flex items-center justify-center gap-2 border border-[#3a3a42] text-white font-display uppercase tracking-[0.12em] text-xs py-3.5"
    >
      <Phone className="w-4 h-4" /> Call Now
    </a>
    <Link
      to="/book"
      data-testid="sticky-mobile-book-button"
      className="inline-flex items-center justify-center gap-2 bg-[#EA0A0B] text-white font-display uppercase tracking-[0.12em] text-xs py-3.5"
    >
      Book Online <ArrowUpRight className="w-4 h-4" />
    </Link>
  </div>
);
